import moment from 'moment';
import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import {Form, FormGroup, Input,} from 'reactstrap';
import trainingPhasesActionCreators from '../../../store/training-phases/action-creators/index';
import Checkbox from "../../../../shared/forms/Checkbox";

class AcknowledgementForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isChecked: false,
      acknowledgedAt: null,
      ackComment: '',
      requireAckComment: this.props.requireAckComment
    };
  }

  // ----------------------
  // Methods
  // ----------------------

  handleInput() {
    const state = !this.state.isChecked
      ? {isChecked: true, acknowledgedAt: new Date()}
      : {isChecked: false, acknowledgedAt: null};
    this.setState({...state});
  }

  setComment(ackComment) {
    this.setState({
      ackComment
    })
  }

  handleSubmit(event) {
    event.preventDefault();
    if(!this.props.canSkip && this.state.requireAckComment && !this.state.ackComment) {
      return
    }
    if (this.props.canSkip) {
      this.props.skipAck({
        guid: this.props.reportGuid,
        date: this.state.acknowledgedAt,
      });
    } else {
      const formData = {
        acknowledgedAt: this.state.acknowledgedAt,
        ackComment: this.state.ackComment,
        guid: this.props.reportGuid,
        responsesAck: this.props.responsesAck
      };
      this.props.acknowledgeReport(formData);
    }
  }

  // ----------------------
  // Render
  // ----------------------

  render() {
    return (
      <Form noValidate onSubmit={event => this.handleSubmit(event)}>
        {this.props.canSkip ?
          <FormGroup>
            <Checkbox
              label="Skip next signoff"
              name="acknowledgement"
              onChange={() => this.handleInput()}/>
          </FormGroup> :
          <FormGroup>
            <Checkbox
              label="Acknowledge"
              name="acknowledgement"
              onChange={() => this.handleInput()}/>
          </FormGroup>
        }
        {!this.props.canSkip && <FormGroup>
          <Input
            type="textarea"
            placeholder="Comment"
            value={this.state.ackComment}
            onChange={(event) => this.setComment(event.target.value)}
          />
        </FormGroup>}
        {this.state.acknowledgedAt &&
        <div>
          <label>
            {moment().format('HH:mm on MMM D, YYYY')}
          </label>
        </div>
        }
        {!this.props.canSkip && this.state.isChecked && this.props.requriedAckResponsesFilled &&
        <Fragment>
          {this.props.userContext.hasScope(['oit']) && (
            <div style={{fontSize: '0.8em'}}>I acknowledge that I have reviewed and fully understand all of the details
              of this form and I am comfortable appropriately executing this training experience
            </div>
          )}

          <button className="button primary">
            Submit
          </button>
        </Fragment>
        }
        {!this.props.canSkip && this.state.requireAckComment && (
          <div style={{fontSize: '0.9em', color: '#bf292a'}}>
            You must fill the comment before you can submit
          </div>
        )}
        {this.props.canSkip && this.state.isChecked && (
          <button className="button primary">
            Submit
          </button>
        )}
        {!this.props.canSkip && this.state.isChecked && !this.props.requriedAckResponsesFilled && (
          <div style={{fontSize: '0.9em', color: '#bf292a'}}>
            You must fill the acknowledgement comments for responses before you can submit
          </div>
        )}

      </Form>
    );
  }
}

// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = (state) => {
  return {
    userContext: state.common.userContext,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    acknowledgeReport: (formData) => {
      dispatch(trainingPhasesActionCreators.acknowledgeReport(formData));
    },
    skipAck: (formData) => {
      dispatch(trainingPhasesActionCreators.skipAck(formData));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AcknowledgementForm);
